module.exports = __webpack_public_path__ + "img/italic.c46b9c4a.svg";